<template>
  <v-col class="d-flex flex-column text-center">
    <div v-if="small" class="mt-8"></div>
    <v-spacer></v-spacer>
    <v-card
      flat
      class="radius mx-auto"
      :class="small ? 'px-5' : 'px-12'"
      max-width="485"
      :min-width="$vuetify.breakpoint.lgAndUp ? 485 : 340"
    >
      <v-container fluid>
        <v-row>
          <v-col class="d-flex justify-center ma-2">
            <v-img
              src="../assets/logo_text_bellow.png"
              :max-height="small ? 80 : 105"
              contain
              max-width="110"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="flex-column mb-0" :class="small ? 'ma-3 px-4' : 'ma-6'">
            <p class="font-weight-bold subtitle-2 text-center mb-0 ubuntu">
              Welcome back!
              <br />
              <span class="font-weight-light subtitle-2 ubuntu">Please login to your account.</span>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center">
            <v-form ref="form">
              <v-text-field
                v-model="email"
                label="Email"
                placeholder=" "
                @keydown.enter="focusPassword"
                :error-messages="loginErrors"
                :rules="[(v) => !!v || 'Email required.', rules.email]"
                validate-on-blur
              ></v-text-field>
              <v-text-field
                ref="password"
                v-model="password"
                label="Password"
                placeholder=" "
                @keydown.enter="loginUser"
                :type="!revealPassword ? 'password' : ''"
                :rules="[(v) => !!v || 'Password required.']"
                :error-messages="loginErrors"
                :append-icon="revealPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="revealPassword = !revealPassword"
              />
              <div class="d-flex space-between align-center">
                <v-checkbox dense>
                  <template #label>
                    <span class="caption">Remember me</span>
                  </template>
                </v-checkbox>
                <a
                  @click="goForgot"
                  class="ma-auto ml-10 font-weight-light caption"
                  text
                  color="#707070"
                  >Forgot Password?</a
                >
              </div>
              <v-card-actions>
                <v-row justify="center" class="px-1">
                  <v-btn
                    class="text-capitalize white--text"
                    depressed
                    width="120"
                    color="#FF347C"
                    @click="loginUser"
                    :loading="loading"
                    >Login</v-btn
                  >
                </v-row>
              </v-card-actions>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-spacer></v-spacer>
    <Copyright />
  </v-col>
</template>

<script>
import Copyright from "@/components/Copyright";
import LogRocket from "logrocket";

export default {
  name: "Login",
  components: {
    Copyright,
  },
  data: () => ({
    rules: {
      email: (v) => {
        const re =
          /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(v)) return true;
        return "Must be a valid e-mail.";
      },
    },
    email: "",
    password: "",
    wrongCred: false, // activates appropriate message if set to true
    loading: false, // property for button loading button state
    revealPassword: false,
  }),
  computed: {
    loginErrors() {
      if (this.wrongCred) {
        return "Invalid username or password.";
      }
      return "";
    },
    small() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {},
  methods: {
    goForgot() {
      window.location.assign("/app/auth/forgot");
    },
    async loginUser() {
      // call loginUSer action
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        await this.$store.dispatch("loginUser", {
          email: this.email,
          password: this.password,
        });

        if (this.$store.getters.profile && process.env.NODE_ENV !== "development") {
          LogRocket.identify(this.$store.getters.profile.uuid, {
            name: this.$store.getters.profile.first_name,
            email: this.$store.getters.profile.email,
          });
        }
        this.wrongCred = false;
        const next = this.$store.getters.next;
        if (next) {
          this.$router.push(next);
          this.$store.commit("next", null);
        } else this.$router.push({ name: "modules" });
      } catch (error) {
        this.wrongCred = true; // if the credentials were wrong set wrongCred to true
      }
      this.loading = false;
    },
    focusPassword() {
      this.$refs.password.focus();
    },
  },
};
</script>
<style scoped>
.ubuntu {
  font-family: Ubuntu !important;
}
</style>
